import $axios from "../api/accessor";
import { $api } from "../api/api";
export const ReferalServices = {
  async GetReferal(url?: string) {
    let response = await $axios
      .get(url || $api("get_ReferalAccount"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async GetReferalList(status: string, url?: string) {
    const endpoint = url || $api("get_referalList", { status: status });

    let response = await $axios
      .get(endpoint, {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => err.response);

    return {
      data: response?.data || [],
      status: response?.status,
    };
  },
  async PostNewReferal(payload: any) {
    try {
      const response = await $axios.post($api("post_Newreferal"), payload, {
        headers: {
          "Accept-Language": "az",
        },
      });
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },

  async PostReferal(payload: any) {
    try {
      const response = await $axios.post($api("add_referal"), payload, {
        headers: {
          "Accept-Language": "az",
        },
      });
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },

  async PostRedirectReferalAccount(payload: any) {
    try {
      const response = await $axios.post(
        $api("redirect_referal_account"),
        payload,
        {
          headers: {
            "Accept-Language": "az",
          },
        }
      );
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },

  async referalRequestList() {
    try {
      const response = await $axios.get($api("referal_request_list"), {
        headers: {
          "Accept-Language": "az",
        },
      });
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },

  async returnToMainAccount() {
    try {
      const response = await $axios.get($api("retrun_to_main_account"), {
        headers: {
          "Accept-Language": "az",
        },
      });
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },
  async Watch_ReferalPackages(type: string, id: string) {
    let response = await $axios
      .get(
        $api("Watch_ReferalPackages", {
          status: type,
          referal: id,
        }),
        {
          headers: {
            "Accept-Language": "az",
          },
        }
      )
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async acceptRequest(id: number) {
    try {
      const response = await $axios.post(
        $api("accept_request"),
        { id: id },
        {
          headers: {
            "Accept-Language": "az",
          },
        }
      );
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },

  async rececjRequest(id: number) {
    try {
      const response = await $axios.post(
        $api("reject_request"),
        { id: id },
        {
          headers: {
            "Accept-Language": "az",
          },
        }
      );
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },
};
